import React from 'react';

import Item from './Item';

type NavbarProps = {
  children: React.ReactNode;
  active: string;
  onSelect: (id: string) => () => void;
};

function Navbar({children, active, onSelect}: NavbarProps) {
  return (
    <div className="flex justify-between items-center rounded-large bg-skyblue p-1 focus:outline-none transition-float text-dodger-blue cursor-pointer">
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          const {
            data: {id},
          } = child.props;

          return React.cloneElement(
            child,
            {
              active: active === id,
              onClick: onSelect(id),
            },
            null
          );
        }
        return child;
      })}
    </div>
  );
}

Navbar.Item = Item;

export default Navbar;
